import {Component, inject, Injector, OnInit} from '@angular/core';

import {TableComponent} from '@shared/components/table/table.component';
import {TableConfig} from '@shared/interfaces/table/table-config';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {ConnectionPointHistoricalDto, ConnectionPointService} from '@app/api/nts';
import {connectionpointHistoryTable} from '@shared/table-configs/connectionpoint/connectionpoint-history.table';
import {TranslatePipe} from '@ngx-translate/core';
import {statePartial} from '@shared/partials/state.partial';
import {TableCellComponent} from '@shared/components/table/table-cell/table-cell.component';
import {FlattenedConnectionPointHistoricalDto} from '@shared/interfaces/dto/FlattenedConnectionPointHistoricalDto';

@Component({
  selector: 'app-connectionpoint-history',
  imports: [
    TableComponent,
    TranslatePipe,
    TableCellComponent
],
  templateUrl: './connectionpoint-history.component.html',
  styleUrl: './connectionpoint-history.component.css'
})
export class ConnectionpointHistoryComponent implements OnInit {
  injector = inject(Injector);
  public tableData: FlattenedConnectionPointHistoricalDto[] = [];
  public id!: string;
  public selectedElements: FlattenedConnectionPointHistoricalDto[] = [];
  public readonly connectionpointHistoryTableConfig: TableConfig<ConnectionPointHistoricalDto> = {
    ...connectionpointHistoryTable,
    refreshable: true,
    refresh: () => this.fetchHistory(),
  };
  public dataColumns = [
    {title: 'connectionpoint.history.index', key: 'index'},
    {title: 'connectionpoint.identification', key: 'identification'},
    {title: 'connectionpoint.alternativeIdentification', key: 'alternativeIdentification'},
    {title: 'connectionpoint.stationsNumber', key: 'stationNumber'},
    statePartial,
    {title: 'connectionpoint.maximumPower', key: 'maximumPower'},
    {title: 'connectionpoint.maximumCurrent', key: 'maximumCurrent'},
    {title: 'address.streetCode', key: 'streetCode'},
    {title: 'address.streetName', key: 'streetName'},
    {title: 'address.streetNumber', key: 'buildingNumber'},
    {title: 'address.floor', key: 'floorIdentification'},
    {title: 'address.roomIdentification', key: 'roomIdentification'},
    {title: 'address.city', key: 'cityName'},
    {title: 'address.zipCode', key: 'postalCode'},
    {title: 'address.municipalcode', key: 'municipalityCode'},
    {title: 'address.countrycode', key: 'country'},
    {title: 'address.daraddress', key: 'darReference'},
  ];


  constructor(
    private readonly connectionPointService: ConnectionPointService,
    private readonly route: ActivatedRoute,
  ) {
  }

  getValueByKey(obj: any, key: string): any {
    return key.split('.').reduce((acc, part) => acc?.[part], obj);
  }

  renderValue(row: any, col: any): string {
    return this.getValueByKey(row, col.key);
  }

  createRendererInjector(row: any, col: any): Injector {
    return Injector.create({
      providers: [
        {provide: 'value', useValue: this.getValueByKey(row, col.key)},
        {provide: 'row', useValue: row},
        {provide: 'column', useValue: col},
        {
          provide: 'params', useValue: {
            key: col.key,
            cellRendererParams: col.cellRendererParams
          }
        }
      ],
      parent: this.injector
    });
  }


  public ngOnInit(): void {
    this.route.parent?.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;
      this.fetchHistory();
    });
  }

  public fetchHistory(): void {
    if (!this.id) return;
    this.connectionPointService.connectionPointGethistoricalGet(this.id).subscribe(data => {
      const sortedData = (data ?? []).sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
      this.tableData = this.flattenData(sortedData);
    });
  }


  private flattenData(data: ConnectionPointHistoricalDto[]): FlattenedConnectionPointHistoricalDto[] {
    return data.map(item => {
      return {
        index: item.index,
        identification: item.identification,
        alternativeIdentification: item.alternativeIdentification,
        stationNumber: item.stationNumber,
        state: item.state,
        maximumPower: item.maximumPower,
        maximumCurrent: item.maximumCurrent,
        date: item.date,
        action: item.action,
        changeBy: item.changeBy,

        streetCode: item.address?.streetCode,
        streetName: item.address?.streetName,
        buildingNumber: item.address?.buildingNumber,
        floorIdentification: item.address?.floorIdentification,
        roomIdentification: item.address?.roomIdentification,
        cityName: item.address?.cityName,
        postalCode: item.address?.postalCode,
        municipalityCode: item.address?.municipalityCode,
        country: item.address?.country,
        darReference: item.address?.darReference
      };
    });
  }
}
